markError